import {notificationsSvg as Icon__small__notificationsSvg} from '../Icon__small/Icon__small--notifications.js';

export var notifications = {
  name: 'notifications',
  category: 'icon',
  colorable: true,
  svg: Icon__small__notificationsSvg,
};
